import Levels from './_data/Levels'
export function getCurrentLevelFromXp(currentXp, xpArray=Levels) {
  const index = xpArray.findIndex(d => d > currentXp) - 1;
  if (index < 0) {
    return xpArray.length - 1
  }
  return index;
}